import styled from 'styled-components';
import Theme from '../../../styles/Theme/Theme';

type TSvgStyled = {
    customColor?: keyof typeof Theme.color;
};

export const SvgStyled = styled.svg<TSvgStyled>`
    > path {
        fill: ${({ fill, customColor, theme }) => {
            if (customColor) return theme.color[customColor];
            if (fill && fill !== "none") return fill;
        }};
        /* stroke: ${({ stroke, customColor, theme }) => {
            if (customColor) return theme.color[customColor];
            return stroke ? stroke : '#222222';
        }}; */
    }
`;
